<p-sidebar [(visible)]="showSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div>
            <div style="margin: 20px 0px 0px 5px;">
                <a style="opacity: 0.5; color: #333333; letter-spacing: -0.43px; font: normal normal bold 18px/12px Montserrat; ">Promo ID: </a>
                <a style="opacity: 1; color: #333333; font: normal normal bold 18px/12px Montserrat; ">{{promoId}}</a>
            </div>
            <div>
                <span class="promoActive" *ngIf="promo.IsActive">Active</span>
                <span class="promoInActive" *ngIf="!promo.IsActive">Inactive</span>
                <p-inputSwitch [(ngModel)]="promo.IsActive" (click)="changePromoActive(promo)"></p-inputSwitch>
            </div>
        </div>
    </ng-template>

    <div class="bg-menu">
        <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="menuItems[0]"></p-tabMenu>
    </div>

    <div class="promo-detail-body">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 300px)'}"
                       [styleClass]="'app-scrollpanel'" *ngIf="promo !== null">
            <div class="promo-detail-img">
                <img src="{{promo.CoverUrl}}" />
            </div>
            <div class="flex flex-row">
                <div class="promo-column-30">
                    <div class="promo-label">Promo Name</div>
                </div>
                <div class="promo-column-70">
                    <div class="promo-text">{{promo.Name}}</div>
                </div>
            </div>
            <div class="flex flex-row">
                <div class="promo-column-30">
                    <div class="promo-label">Promo Code</div>
                </div>
                <div class="promo-column-70">
                    <div class="promo-text">{{promo.Code}}</div>
                </div>
            </div>
            <div class="flex flex-row">
                <div class="promo-column-30">
                    <div class="promo-label">Promo Type</div>
                </div>
                <div class="promo-column-70">
                    <div class="promo-text">{{promo.PromoTypeText}}</div>
                </div>
            </div>
            <div class="flex flex-row">
                <div class="promo-column-30">
                    <div class="promo-label">Internal Reference</div>
                </div>
                <div class="promo-column-70">
                    <div class="promo-text">-</div>
                </div>
            </div>
            <div class="flex flex-row">
                <div class="promo-column-30">
                    <div class="promo-label">Description</div>
                </div>
                <div class="promo-column-70">
                    <div class="promo-text">{{promo.Description}}</div>
                </div>
            </div>
        </p-scrollPanel>

        <hr style="margin-left: -1rem; margin-right: -1rem;" />

        <div class="flex justify-content-end">
                <button pButton type="button" label="Edit" class="p-button btn-promo-edit"
                        style="width: 140px"
                        (click)="openEditPromo()"></button>
        </div>
    </div>
</p-sidebar>